'use strict';

import {ngDepModel} from './ngdepmodel.js';

export class wpModel extends ngDepModel
{
	constructor(itemData, $filter, jsDataService){
		super(itemData, $filter, jsDataService);
		this.setupItemData(itemData);
	}
	
	afterSetup(data){
//		if(typeof(this.a3_participants_legal_status) === 'object'){
//			this.a3_participants_legal_status = Object.values(this.a3_participants_legal_status);
//		}
	}
	
	getValue(name){
		switch(name){
			case 'a4_1_work_activities_duration':
				if(isNaN(this.a4_1_work_activities_end)){
					return '';
				}
				if(isNaN(this.a4_1_work_activities_start)){
					return '';
				}
				if(this.a4_1_work_activities_start < 1 || this.a4_1_work_activities_end < 1 ){
					return '';
				}
				const rez = (parseInt(this.a4_1_work_activities_end) - (parseInt(this.a4_1_work_activities_start) - 1));
				if(rez < 1){
					return '';
				}
				return rez;
			case 'wptitle':
				return this.a4_1_work_activities_no + ' ' + this.a4_1_work_activities_name;
			case 'funding_form':
				return this.getClassifValue(name, 'funding_form');
			case 'completion_status':
				return this.getClassifValue(name, 'completion_status');
		}
		if(typeof(this[name]) !== 'undefined' && this[name] !== ''){
			return this[name];
		}
		return null;
	}
}
